type ExploreSortItem = {
  value: string;
  label: string;
};

type GetLorebookExploreSortItemsArgs = {
  collectionName: string;
  textMatchPrefix: string;
  translate: (key: string, options?: { defaultValue?: string }) => string;
};

export default function getLorebookExploreSortItems({
  collectionName,
  textMatchPrefix,
  translate,
}: GetLorebookExploreSortItemsArgs): ExploreSortItem[] {
  return [
    {
      value: `${collectionName}/sort/${textMatchPrefix},createdAt:desc`,
      label: translate("search:sortBy.latest"),
    },
    {
      value: `${collectionName}/sort/${textMatchPrefix},createdAt:asc`,
      label: translate("search:sortBy.oldest"),
    },
    {
      value: `${collectionName}/sort/num_attaches:desc,createdAt:desc`,
      label: translate("search:sortBy.popular"),
    },
    {
      value: `${collectionName}/sort/${textMatchPrefix},num_entries:desc,createdAt:desc`,
      label: translate("search:sortBy.entriesAmount", { defaultValue: "Most Entries" }),
    },
  ];
}
